// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { getDescriptiveListingGridSizes } from '../../utils/gridHelpers';
import HorizontalItem from './items/HorizontalItem';
import InfiniteGrid from './items/InfiniteGrid';
import * as visualStyles from './VisualListing.scss';
export default function DescriptiveListing(props) {
    useStyles(visualStyles);
    const { windowWidth } = useSelector((state) => state.BrowserState);
    return (React.createElement(Fragment, null,
        props.data.header && (React.createElement("div", { className: visualStyles.header },
            React.createElement("h1", { className: "music-headline-4" }, props.data.header))),
        React.createElement(InfiniteGrid, { data: props.data, handleSelected: props.handleSelected, componentType: HorizontalItem, gridSizes: getDescriptiveListingGridSizes(windowWidth), isEnumerated: props.isEnumerated })));
}
